import cn from 'classnames';

export default function Title({ title, className, prefix }) {
  return <h1 className={cn(`${prefix}text-sm ${prefix}font-bold ${prefix}font-lato ${prefix}h-[14px] ${prefix}line-clamp-1 ${prefix}leading-none`, className)}>{title}</h1>;
}
